module.exports = __webpack_public_path__ + "img/logo-army-60.94a3f3bc.png";